var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.componentStates,
      attrs: { "data-component": "base-item" },
      on: { click: _vm.onClick },
    },
    [
      _c("base-item-info", {
        attrs: {
          person: _vm.person,
          avatar: _vm.avatar,
          icon: _vm.icon,
          size: _vm.size,
          title: _vm.title,
          description: _vm.description,
          status: _vm.status,
          "status-type": _vm.statusType,
          "is-disabled": _vm.isDisabled,
        },
      }),
      _vm._v(" "),
      _vm.actions && _vm.actions.length
        ? _c(_vm.actionsComponentType, {
            tag: "component",
            attrs: {
              actions: _vm.actions,
              size: _vm.size,
              description: _vm.actionsDescription,
              "show-action-icons": _vm.showActionIcons,
              "is-disabled": _vm.isDisabled,
            },
            on: {
              "action-click": function ($event) {
                return _vm.$emit("action-click", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }